import styled from "styled-components";
import { FiChevronRight, FiCornerDownRight } from "react-icons/fi";

import FlexBox from "../FlexBox";
import { DAVYS_GREY, PLUM_PURPLE } from "../colors";
import { Body2, Caption } from "../Headings";

const ChatList = styled(FlexBox)`
  flex-direction: column;
  padding-bottom: 1rem;
`;

const GroupContainer = styled(FlexBox)`
  flex-direction: column;
`;

const GroupLabel = styled(Caption)`
  padding: 1rem 1em 0.75rem 1rem;
  color: ${DAVYS_GREY[700]};
`;

const GroupItems = styled(FlexBox)`
  flex-direction: column;
`;

const ChatItem = styled(FlexBox)`
  padding: 0.75rem 1rem;
  border-top: ${({ $showItemDivider }) =>
    $showItemDivider ? `1px solid ${DAVYS_GREY[300]}` : "none"};
  cursor: pointer;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: ${DAVYS_GREY[100]};
  }
`;

const ChatItemLeft = styled(FlexBox)`
  align-items: flex-start;
  column-gap: 0.75rem;
  min-width: 0;
`;

const ChatText = styled(FlexBox)`
  flex-direction: column;
  row-gap: 0.25rem;
  min-width: 0;
`;

const ChatTitle = styled(Body2)`
  color: ${DAVYS_GREY[900]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ChatMeta = styled(Caption)`
  color: ${DAVYS_GREY[600]};
`;

const Divider = styled.div`
  border-top: 4px solid ${DAVYS_GREY[300]};
`;

const AiChatHistoryGroupedList = ({
  groupedHistory,
  getLastChatLabel,
  onSelectChat,
  loadingConversationId,
}) => (
  <ChatList>
    {groupedHistory.map(group => (
      <GroupContainer key={group.key}>
        <GroupLabel bold spacing="0.1rem" textTransform="uppercase">
          {group.label}
        </GroupLabel>

        <GroupItems>
          {group.items.map((chat, index) => (
            <ChatItem
              key={chat.id || `${group.key}-${index}`}
              $showItemDivider={group.items.length > 1 && index > 0}
              onClick={() => onSelectChat?.(chat)}
            >
              <ChatItemLeft>
                <FiCornerDownRight
                  size={18}
                  color={PLUM_PURPLE[700]}
                  style={{ marginTop: "0.15rem", flexShrink: 0 }}
                />

                <ChatText>
                  <ChatTitle>{chat.title || "Untitled conversation"}</ChatTitle>
                  <ChatMeta>{getLastChatLabel(chat.updatedAt)}</ChatMeta>
                </ChatText>
              </ChatItemLeft>

              {loadingConversationId === chat.id ? (
                <Caption bold>Loading...</Caption>
              ) : (
                <FiChevronRight size={18} />
              )}
            </ChatItem>
          ))}
        </GroupItems>

        <Divider />
      </GroupContainer>
    ))}
  </ChatList>
);

export default AiChatHistoryGroupedList;
